import React from 'react'
import { graphql } from 'gatsby'

import type { MediaComponent, DrupalMediaBase } from './types'

import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Figure from '../Figure'
import { DrupalFile } from '../../drupal';

export interface MediaImage extends DrupalMediaBase {
	__typename: 'media__image'
	field_media_image: {
		alt?: string
	}
	field_caption?: {
		processed: string
	}
	relationships: {
    field_media_image: DrupalFile
  }
}

const MediaImageComponent: MediaComponent<MediaImage> = ({ className, media, title }) => {
  const image = getImage(media.relationships.field_media_image.localFile);

  return image ? (
    <Figure className={className} caption={media.field_caption?.processed}>
      <GatsbyImage
        image={image}
        alt={media.field_media_image.alt || ""} />
    </Figure>
  ) : <></>
}

export default MediaImageComponent

export const query = graphql`fragment MediaImage on media__image {
  __typename
  mid: drupal_internal__mid
  field_media_image {
    alt
  }
  field_caption {
    processed
  }
  relationships {
    field_media_image {
      localFile {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
    }
  }
}

fragment MediaImageTeaser on media__image {
  __typename
  mid: drupal_internal__mid
  field_media_image {
    alt
  }
  relationships {
    field_media_image {
      localFile {
        childImageSharp {
          gatsbyImageData(width: 380, layout: FULL_WIDTH)
        }
      }
    }
  }
}`
